'use strict';

module.exports = ({ dispatch, getState }) => {
    return (next) => {
        return (action) => {
            return typeof action === 'function' ?
                action(dispatch, getState) :
                next(action);
        };
    };
};



// WEBPACK FOOTER //
// ./client/src/middleware/thunk-middleware.js